import { Component, OnInit } from "@angular/core";
export interface CatalogPublication {
  image_url: string;
  content_text: string;
  val_1: string;
  text_1: string;
  val_2: string;
  text_2: string;
  val_3: string;
  text_3: string;
  url_direction: string;
}
@Component({
  selector: "app-publicaciones-view",
  templateUrl: "./publicaciones-view.component.html",
  styleUrls: ["./publicaciones-view.component.css"],
})
export class PublicacionesViewComponent implements OnInit {
  constructor() { }

  catalogPublicationList!: CatalogPublication[];

  ngOnInit(): void {
    document.getElementsByClassName("head")[0].scrollIntoView();
    this.catalogPublicationList = [
      {
        image_url: "https://wikipapa.org/images/covers-catalogos-junin.jpg",
        content_text:
          "Catálogo de variedades de papa nativa del sureste del departamento de Junín - Perú",
        val_1: "Peru",
        text_1: "JUNIN",
        val_2: "147",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "10",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/89110",
      },

      {
        image_url:
          "https://wikipapa.org/images/covers-catalogos-huancavelica.jpg",
        content_text:
          "Catálogo de variedades de papa nativa de Huancavelica - Perú",
        val_1: "Peru",
        text_1: "HUANCAVELICA",
        val_2: "251",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "10",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/101328",
      },

      {
        image_url: "https://wikipapa.org/images/covers-catalogos-chugay.jpg",
        content_text:
          "Catálogo de variedades de papa nativa del Chugay, La Libertad - Perú Catalog of ancestral potato varieties from Chugay, La Libertad - Perú",
        val_1: "Peru",
        text_1: "LA LIBERTAD",
        val_2: "251",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "10",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/69083",
      },

      {
        image_url:
          "https://wikipapa.org/images/covers-catalogos-huancavelica-2021.jpg",
        content_text:
          "Línea de Base de la Diversidad de Papa Nativa del Microcentro Yauli - Paucará, Huancavelica, Perú",
        val_1: "Peru",
        text_1: "YAULI PAUCARA HUANCAVELICA",
        val_2: "148",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "8",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/113985",
      },

      {
        image_url:
          "https://wikipapa.org/images/covers-catalogos-nuevas-varied.jpg",
        content_text:
          "Catálogo de nuevas variedades de papa: sabores y colores para el gusto peruano",
        val_1: "Peru",
        text_1: "JUNIN",
        val_2: "45",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "5",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/101327",
      },

      {
        image_url: "https://wikipapa.org/images/covers-catalogos-apurimac.jpg",
        content_text:
          "Catálogo de variedades de papa nativa con potencial para la seguridad alimentaria y nutricional de Apurímac y Huancavelica",
        val_1: "Peru",
        text_1: "APURIMAC, HUANCAVELICA",
        val_2: "24",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "4",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/65115",
      },

      {
        image_url: "https://wikipapa.org/images/covers-catalogos-miski.jpg",
        content_text:
          "Catálogo Miski papa. Regalo de los Andes. Colecciones de los guardianes de papa nativa",
        val_1: "Peru",
        text_1: "JUNIN, LIMA, HUANCAVELICA",
        val_2: "60",
        text_2: "VARIEDADES DE PAPAS",
        val_3: "6",
        text_3: "COMUNIDADES",
        url_direction: "https://cgspace.cgiar.org/handle/10568/111806",
      },
    ];
  }

  fnItem(url: string) {
    window.open(url, "_blank");
  }
}
